// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastProjectSchema = z.object({
  id: z.number().int().describe("Project ID"),
  active: z.boolean().describe("Whether the project is active"),
  name: z.coerce.string().describe("Project name"),
  color: z.coerce.string().describe("Hex color code"),
  client: z.object({
    id: z.number().int().describe("Client ID"),
    name: z.coerce.string().describe("Client name"),
    color: z.coerce.string().describe("Hex color code"),
    active: z.boolean().describe("Whether the client is active"),
    external_id: z.coerce.string().describe("External ID").nullish(),
    updated_at: z.coerce.string().describe("ISO 8601 timestamp"),
  }).describe("Client associated with the project"),
  updated_at: z.coerce.string().describe("ISO 8601 timestamp"),
});
